Storage.prototype.setObject = function (key, value) {
  const str = JSON.stringify(value);
  this.setItem(key, str);
};

Storage.prototype.getObject = function (key) {
  const item = this.getItem(key);
  return item && JSON.parse(item);
};

/* eslint-disable */
Date.prototype.toElapsedString = function () {
  const now = new Date();
  const millis = (now - this);
  const seconds = millis / 1000;
  const minutes = seconds / 60;
  const hours = minutes / 60;
  const days = hours / 24;
  const months = days / 30;
  const years = days / 365;

  const dictionary = {
    seconds: ['segundo', 'segundos'],
    minutes: ['minuto', 'minutos'],
    hours: ['hora', 'horas'],
    days: ['dia', 'dias'],
    months: ['mês', 'meses'],
    years: ['ano', 'anos'],
  };

  const list = {
    years,
    months,
    days,
    hours,
    minutes,
    seconds,
  };

  for (const key in list) {
    const value = Math.floor(list[key]);
    if (value >= 1) {
      const name = dictionary[key][value === 1 ? 0 : 1];
      return `${value} ${name} atrás`;
    }
  }

  return 'agora';
};

export default {
  async request(action) {
    let response = false;
    try {
      response = await action || null;
      if (response instanceof Promise) {
        return response;
      }
    } catch (error) {
      console.error(error.message);
    }
    return response;
  },
};



// WEBPACK FOOTER //
// ./src/services/utils.js